import Container from "@mui/material/Container";
import MainContent from "./MainContent";
import Sidebar from "./Sidebar/Sidebar";
import { Stack } from "@mui/material";

const Body = props => {
    const hasSidebar = Boolean(props.sideBar);

    return <>
        <Container maxWidth="lg" sx={{ boxSizing: { xs: 'border-box', sm: 'initial' }, p: 0 }} fixed>
            <Stack direction={{ xs: 'column', sm: "row" }} alignItems={"start"} spacing={2} sx={{ my: { xs: 0, sm: 2 } }}>
                {hasSidebar && <Sidebar content={props.sideBar} />}
                <MainContent content={props.mainElement} />
            </Stack>
        </Container>
    </>
}

export default Body;
